<template>
  <a-modal
    :title="title"
    :width="750"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 18 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
          prop="userId"
          label="选择用户">
          <a-select v-model="model.userId" placeholder="请选择用户" show-search allowClear :filter-option="filterOption" @change="handleChange">
            <a-select-option
                      v-for="(item,index) in userList"
                      :key="index"
                      :value="item.userId">
                      {{ item.realname }}
                    </a-select-option>
          </a-select>
        </a-form-model-item>        
        <a-form-model-item
            prop="eventTime"
          label="发生时间">
          <a-date-picker v-model="model.eventTime" show-time  format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"  placeholder="请输入发生时间"/>
        </a-form-model-item>
        <a-form-model-item
            prop="type"
          label="事件类型">
          <a-select v-model="model.type" style="width: 100%">
                    <a-select-option :value="0">
                      其他
                    </a-select-option>
                    <a-select-option :value="1">
                      投诉
                    </a-select-option>
                  </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="内容">
          <a-textarea :rows="6" placeholder="请输入事件内容" v-model="model.content" />
        </a-form-model-item>       

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import baseRules from '@/constants/baseRules'
  import { getAction,putAction } from '@/api/manage'

  export default {
    name: "EventModal",
    props: {
      projectId: {
        type: String,
        default: ''
      },
    },
    components: { ATextarea },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        userList:[],
        rules:{
          userId:[baseRules.requiredChange],
          eventTime:[baseRules.requiredChange],
          type:[baseRules.requiredChange],          
        },
        confirmLoading: false,
        isView:false,
        url: {
          save: "/project/projectEvent/save",
        },
      }
    },
    created () {
    },
    mounted() {
      this.getUserList();
    },
    methods: {
      add () {
        this.edit({
          projectId:this.projectId,
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      view (record) {
        this.isView = true
        this.edit(record)
      },
      close () {
        this.$emit('close');
        this.isView = false
        this.visible = false;
      },
      handleOk () {
        if(this.isView){
          return
        }
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            
            let formData = this.model;

            putAction(this.url.save,formData).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      getUserList(){
        getAction('/project/projectUser/listAll', { projectId: this.projectId }).then(res => {
          if (res.success) {
            this.userList = res.result
          }else{
            this.$message.warning(res.message)
          }
        })        
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleChange(value, options){
        if (value === undefined || value === null) {
          this.model.realName = null          
          return
        }

        // 根据 userId 从 userList 中查找完整对象
        const selectedItem = this.userList.find(user => user.userId === value)

        if (selectedItem) {          
          this.model.realName = selectedItem.realname
        }
      },
    }
  }
</script>

<style lang="less" scoped>

</style>